
import * as $ from "jquery";

export class CATEGORYEDIT {
	static getVal(o, key, def) {
		if (typeof key == 'undefined' || typeof o == 'undefined') {
			return def;
		}
		else if (typeof def == 'undefined') {
			return '';
		}
		else {
			var temp = o;
			key = String(key).split('.');
			for (var i in key) {
				if (typeof temp[key[i]] == 'undefined') {
					return def;
				}
				else {
					temp = temp[key[i]];
				}
			}
			return temp;
		}
	}
	static init(jsonResponse, domId, chkbox, treeId, response, categoryType, expand) {

		this.loadSiteCategories(jsonResponse, domId, eval(''), chkbox, treeId, response, expand);
	}

	static createCheckbox(value, THIS, chkbox, response) {
		var checked = '';
		if (chkbox) {

			var res = JSON.parse(THIS.getCurrentCategory(value));

			var categories = response.split('|');
			for (let category in categories) {
				var name = categories[category].substring(categories[category].lastIndexOf('~') + 1);
				var base = categories[category].substring(0, categories[category].lastIndexOf('~'));
				if (unescape(res.name) === unescape(name) && unescape(res.base) === unescape(base)) {
					checked = "<input type='checkbox' checked id='categoryCheck'  name='categoryCheck' value='" + THIS.getCurrentCategory(value) + "'/>";
					break;
				} else {
					checked = "<input type='checkbox'  id='categoryCheck' name='categoryCheck' value='" + THIS.getCurrentCategory(value) + "'/>";
				}
			}
			return checked;

		} else {
			return '';
		}

	}
	static loadSiteCategories(jsonResponse, domId, THIS, chkbox, treeId, response, expand) {
		THIS = this;
		var jsonObjects = jsonResponse;

		var categoryRootHtml = '<ul id="' + treeId + '" class="sitemap">';
		var categoryTreeHtml = '';

		$.each(jsonObjects, function (key, jsonObject) {

			if (jsonObject instanceof Object) {
				categoryTreeHtml += '<li>' + THIS.createCheckbox(jsonObject, THIS, chkbox, response) + '<a  externalUrl="' + THIS.getVal(jsonObject, 'externalUrl', '') +'" moduleType="'+ THIS.getVal(jsonObject, 'moduleType','')+'" description="'+THIS.getVal(jsonObject, 'description','')+'" api_url="'+THIS.getVal(jsonObject, 'api_url','')+'" base="' + jsonObject.base + '" name="' + jsonObject.name + '" nc="' + jsonObject.nc + '" cc="' + jsonObject.cc + '" level="' + jsonObject.level + '" status="' + jsonObject.status + '"class="solmenu editable" href="javascript:void(0);" id="' + jsonObject.id + '_' + jsonObject.base + '_' + jsonObject.name + '">' + jsonObject.name + '</a>';
				THIS.iterateNode(key, jsonObject, THIS, chkbox, response, function (categoryNodeHtml) {
					if (categoryNodeHtml === '')
						categoryTreeHtml += categoryNodeHtml + '</li>';
					else
						categoryTreeHtml += categoryNodeHtml + '</ul></li>';
				});
			}
			else {
				categoryTreeHtml += '<li>' + THIS.createCheckbox(jsonObject, THIS, chkbox, response) + '<a externalUrl="' + THIS.getVal(jsonObject, 'externalUrl', '') +'" moduleType="'+ THIS.getVal(jsonObject, 'moduleType','')+'" description="'+THIS.getVal(jsonObject, 'description','')+'" api_url="'+THIS.getVal(jsonObject, 'api_url','')+'"  base="' + jsonObject.base + '" name="' + jsonObject.name + '" nc="' + jsonObject.nc + '" cc="' + jsonObject.cc + '" level="' + jsonObject.level + '" status="' + jsonObject.status + '" class="solmenu editable" href="javascript:void(0);" id="' + jsonObject.id + '_' + jsonObject.base + '_' + jsonObject.name + '">' + jsonObject.name + '</a></li>';
			}
		});

		categoryRootHtml += categoryTreeHtml + '</ul>';

		$(domId).empty().html(categoryRootHtml);

		if (chkbox) {
			$('UL#' + treeId + ' li a').css('padding-left', '5px');
		}


		THIS.categoryStyler(domId, treeId);
		if (expand) {
			$('UL#' + treeId + ' li span').addClass('expanded');
			$('UL#' + treeId + ' ul').css('display', 'block');
		}
	}
	static iterateNode(key, jsonObjects, THIS, chkbox, response, callback) {
		var categoryNodeHtml = '';
		if (jsonObjects instanceof Object) {
			var firstTime = true;
			var i = 0;
			$.each(jsonObjects, function (key, jsonObject) {
				if (jsonObject instanceof Object) {
					if (firstTime) {
						categoryNodeHtml += '<ul>';
						firstTime = false;
					}

					categoryNodeHtml += '<li>' + THIS.createCheckbox(jsonObject, THIS, chkbox, response) + '<a externalUrl="' + THIS.getVal(jsonObject, 'externalUrl', '') +'" moduleType="'+ THIS.getVal(jsonObject, 'moduleType','')+'" description="'+THIS.getVal(jsonObject, 'description','')+'" api_url="'+THIS.getVal(jsonObject, 'api_url','')+'" base="' + jsonObject.base + '" name="' + jsonObject.name + '" nc="' + jsonObject.nc + '" cc="' + jsonObject.cc + '" level="' + jsonObject.level + '" status="' + jsonObject.status + '" class="solmenu editable" href="javascript:void(0);"  id="' + jsonObject.id + '_' + jsonObject.base + '_' + jsonObject.name + '">' + jsonObject.name + '</a>';
					THIS.iterateNode(key, jsonObject, THIS, chkbox, response, function (nodeToPrint) {
						if (nodeToPrint === '') {
							categoryNodeHtml += nodeToPrint + '</li>';
						}
						else {
							categoryNodeHtml += nodeToPrint + '</ul></li>';
						}
					});
				}
				else {
				}
			});
		}
		else {
			console.log(' Skipping jsonObjects ---> ' + jsonObjects);
			console.log(jsonObjects);
		}
		callback(categoryNodeHtml);
	}

	static getCurrentCategory(jsonObjects) {
		var currentObject = {};
		$.each(jsonObjects, function (key, jsonObject) {
			if (jsonObject instanceof Object) {
			}
			else {
				currentObject[key] = escape(jsonObjects[key]);
			}
		});
		return JSON.stringify(currentObject);
	}
	static categoryStyler(domId, treeId) {
		var sitemap = document.getElementById(treeId);
		if (sitemap) {

			let listItem = function (li) {
				if (li.getElementsByTagName("ul").length > 0) {
					var ul = li.getElementsByTagName("ul")[0];
					ul.style.display = "none";
					var span = document.createElement("span");
					span.className = "collapsed";
					span.onclick = function () {
						//console.log("	$(this)",	$(this));
						ul.style.display = (ul.style.display == "none") ? "block" : "none";
						$(this).attr("class", (ul.style.display == "none") ? "collapsed" : "expanded");
					};
					li.appendChild(span);
				};
			};

			var items = sitemap.getElementsByTagName("li");
			for (var i = 0; i < items.length; i++) {
				listItem(items[i]);
			};

		}

	}


}
